/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface HostSummary { 
    /**
     * Host count by Instance
     */
    hosts_by_instance_type: { [key: string]: number; };
    /**
     * Host count by Region
     */
    hosts_by_region: { [key: string]: number; };
    /**
     * Host count by SDDC state
     */
    hosts_by_sddc_state: { [key: string]: number; };
    /**
     * Host count by User
     */
    hosts_by_user: { [key: string]: number; };
    /**
     * Number of total ESX hosts encountered in all SDDCs, irrespecitive of SDDC state
     */
    num_hosts: number;
}

